export const timezones = [
  'UTC',

  // Europa
  'Europe/London',
  'Europe/Berlin',
  'Europe/Madrid',
  'Europe/Rome',
  'Europe/Paris',
  'Europe/Istanbul',
  'Europe/Moscow',

  // Asia
  'Asia/Dubai',
  'Asia/Karachi',
  'Asia/Kolkata',
  'Asia/Bangkok',
  'Asia/Hong_Kong',
  'Asia/Tokyo',

  // Oceanía
  'Australia/Sydney',
  'Pacific/Auckland',

  // América del Norte
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',

  // América Latina
  'America/Mexico_City',
  'America/Bogota',
  'America/Lima',
  'America/Caracas',
  'America/Sao_Paulo',
  'America/Argentina/Buenos_Aires',
  'America/Guatemala',
  'America/Cancun',
  'America/Puerto_Rico',
  'America/Santiago',
  'America/La_Paz',
  'America/Asuncion',

  // África
  'Africa/Cairo',
  'Africa/Nairobi',
]
